import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Currency from './sub_components/currency'
import * as eventService from '../services/eventService'
import * as dateParser from '../util/date.util'
let openBinary = null;
class BinaryAnalysis extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uid: "",
			passcode: "",
			eventTypes: [],
			casinoData: null,
			openTabs: {},
			binarySequence: ["DAILY", "1_HOUR", "2_HOUR"],
			isBinaryMounted: false
		};
	}

	componentDidMount() {
		this.setState({isBinaryMounted : true},()=>{
			this.dataBuilder()
		});
	}

	componentWillUnmount() {
		// this.setState({isBinaryMounted : false});
		this.state.isBinaryMounted = false;
		clearInterval(openBinary)
	}

	async dataBuilder() {
		let self = this;
		openBinary = setInterval(async function allOpenBinary() {
			clearInterval(openBinary)
			console.log("binary")
			eventService.getAdminEventType().then((res) => {
				if(self.state.isBinaryMounted){	
					if (!!res && !!res.items && res.items.length > 0) {

						let mkts = res.items

						let openMarkets = !!mkts && mkts.filter((mkt) => {
							mkt.dateFormat = new Date(mkt.createdAt).toLocaleDateString("hi-IN")
							return mkt.resultStatus !== "RESULT_DECLARED" && mkt.eventTypeId === "300"
						})

						openMarkets = self.binarySequence(openMarkets)

						let eventGroup = self.arrayGroupBy(openMarkets, "dateFormat")
						let openTab = self.state.openTabs
						Object.keys(eventGroup).forEach((dt, j) => {
							eventGroup[dt] = self.arrayGroupBy(eventGroup[dt], "marketType")
							if (!openTab[dt]) {
								openTab[dt] = Object.keys(eventGroup[dt])[0]
							}
						})

						self.setState({ eventTypes: eventGroup, openTabs: openTab })
						
							openBinary = setInterval(allOpenBinary, 5000)
						

					} else {
							openBinary = setInterval(allOpenBinary, 5000)
					}
				}
			})
		}, 500)
	}

	binarySequence(data) {
		let sequencedData = []

		this.state.binarySequence.forEach((type) => {
			let typData = data.filter((mkt) => { return mkt.marketType === type })
			sequencedData = sequencedData.concat(typData)
		})

		return sequencedData
	}

	arrayGroupBy(ary, attr) {
		let group = ary.reduce((r, a) => {
			r[a[attr]] = [...r[a[attr]] || [], a];
			return r;
		}, {});
		return group
	}

	updateTab(eventType, comp) {
		let openTabs = this.state.openTabs
		openTabs[eventType] = comp
		this.setState({ openTabs: openTabs })
	}

	onChange(e) {
		const name = e.target.name;
		const value = e.target.value;
		this.setState({ [name]: value })
	}

	render() {
		return (
			<div className="bethubs">
				<Header history={this.props.history} />
				<div className="wrapper">
					<div className="container-fluid container-padding-0">
						<div className="row">
							<div className="col-12 col-sm-12 col-md-12 col-lg-12">
								<div className="main-box">
									<h5 className="text-blue">Binary Analysis</h5>
									<div className="row sportanalysis mt-2">
										<div className="col-12 col-sm-12 col-md-12">
											{!!this.state.eventTypes && Object.keys(this.state.eventTypes).length > 0 && Object.keys(this.state.eventTypes).map((eventType, i) => {
												let compitition = this.state.eventTypes[eventType]
												return (<>
													<div className="marketanalysisbox mb-2 binaryanalysis">
														<div className="topbox font-16">
															<b>{eventType}</b>
														</div>
														<div className='binarybox'>
															<ul className="nav nav-tabs  tabs mt-2" role="tablist">
																{Object.keys(compitition).map((comp, j) => {
																	return (
																		<li className="nav-item">
																			<a style={{ cursor: "pointer" }} className={this.state.openTabs[eventType] === comp ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => { this.updateTab(eventType, comp) }} role="tab" >{comp.split("_").join(" ")}</a>
																		</li>
																	)
																})}
															</ul>
															<div className="table-responsive eventmaspage eventcon">
																<table className="table table-bordered font-14 w-100 nowrap mb-0">
																	<thead>
																		<tr className="bg-dark importeve">
																			<td className="event-width40"><span className="font-weight-bold text-white">Markets</span></td>
																			<td className="event-width10 text-right"><span className="font-weight-bold text-white">Total Order</span></td>
																			<td className="event-width12 text-right"><span className="font-weight-bold text-white">Exposure</span></td>
																			<td className="event-width12 text-right"><span className="font-weight-bold text-white">Total Amount</span></td>
																			<td className="event-width12 text-right"><span className="font-weight-bold text-white">Max Profit</span></td>
																		</tr>
																	</thead>
																	<tbody className="bg-white">
																		{compitition[this.state.openTabs[eventType]].map((mkt) => {
																			return (
																				<tr>
																					<td><span className="font-weight-bold"><a href={"/binaryanalysis/" + mkt.eventId} className=" topboxlink">{dateParser.getBinaryMarketDisplayName(mkt.marketName)[0]}</a> </span><span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(mkt.marketName)[1]}</b>]</span></td>
																					<td className="text-right"><span className="font-weight-bold">{mkt.orderCount}</span></td>
																					<td className="text-right"><span className="font-weight-bold">{!!mkt.exposure ? <Currency amount={mkt.exposure} isOnlyNumber={true} showColor={true} /> : "0"}</span></td>
																					<td className="text-right"><span className="font-weight-bold">{Math.round(mkt.totalAmount)}</span></td>
																					<td className="text-right"><span className="font-weight-bold">{Math.round(mkt.maxProfit)}</span></td>
																				</tr>
																			)
																		})}
																	</tbody>
																</table>
															</div>
														</div>
													</div>
												</>)
											})
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		)
	}
}
function mapStateToProps(state) {
	return {
	};
}
function mapDispatchToProps(dispatch) {
	return {
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BinaryAnalysis);